module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "max-w-screen-3xl h-40 relative group bg-black"
  }, [_c('img', {
    staticClass: "w-full h-40 object-cover opacity-60",
    class: _vm.hasTeacherPermissionsInCourse ? 'cursor-pointer' : '',
    attrs: {
      "src": _vm.getCourseDetail.banner_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute top-0 left-0 w-full h-full flex flex-col justify-end xl:flex-row xl:justify-between xl:items-end p-5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3 mb-2.5 xl:mb-0"
  }, [_c('h1', {
    staticClass: "text-white text-3xl select-none font-bold",
    attrs: {
      "title": _vm.roundtables.length
    }
  }, [_vm._v("\n          RoundTables\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [(_vm.getCourseDetail.google_classroom_integration.course_id) ? _c('div', {
    staticClass: "w-6 cursor-pointer h-6 ring-2 bg-white ring-yellow-400 rounded-full",
    attrs: {
      "title": "Google Classroom"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/google_class_round.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.handleSetIntegration('schoology')) ? _c('div', {
    staticClass: "w-7 h-7 ring-1 cursor-pointer ring-blue-600 bg-white rounded-full",
    attrs: {
      "title": "Schoology"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/integrations/Schoology.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.handleSetIntegration('canvas')) ? _c('div', {
    staticClass: "w-6 h-6 ring-2 cursor-pointer bg-white ring-red-500 rounded-full",
    attrs: {
      "title": "Canvas"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/integrations/Canvas.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.handleSetIntegration('microsoft')) ? _c('div', {
    staticClass: "w-6 cursor-pointer h-6 ring-2 bg-indigo-100 ring-purple-light rounded-full flex justify-center items-center",
    attrs: {
      "title": "Microsoft Teams"
    }
  }, [_c('img', {
    staticClass: "w-5 flex justify-center items-center h-5",
    attrs: {
      "src": "/static/integrations/Microsoft.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.handleSetIntegration('brightspace')) ? _c('div', {
    staticClass: "w-6 h-6 cursor-pointer ring-2 bg-white ring-white rounded-full",
    attrs: {
      "title": "Brightspace"
    }
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": "/static/integrations/Brightspace.png"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col lg:flex-row lg:space-x-2 space-y-2 lg:space-y-0"
  }, [_c('div', {
    staticClass: "flex flex-row space-x-2"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2 bg-white border border-solid h-10 shadow-lg border-gray-200 w-80 rounded-lg px-4 opacity-90"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass text-gray-700"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "rounded-lg focus-within:border-white w-full border-white",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('DropdownMenu', {
    scopedSlots: _vm._u([{
      key: "toggle",
      fn: function() {
        return [_c('button', {
          staticClass: "bg-white opacity-90 h-10 w-56 rounded-lg py-2 px-4 flex text-gray-700 items-center shadow-lg justify-between space-x-2"
        }, [(_vm.selected_type === 'All') ? _c('span', [_vm._v("All Discussions")]) : _vm._e(), _vm._v(" "), (_vm.selected_type === 'Written') ? _c('span', [_vm._v("Written RoundTable")]) : _vm._e(), _vm._v(" "), (_vm.selected_type === 'Verbal') ? _c('span', [_vm._v("Verbal RoundTable")]) : _vm._e(), _vm._v(" "), (_vm.selected_type === 'Sequence') ? _c('span', [_vm._v("Sequence")]) : _vm._e(), _vm._v(" "), _c('i', {
          staticClass: "fa-solid text-xs fa-chevron-down text-gray-700"
        })])]
      },
      proxy: true
    }, {
      key: "menu-content",
      fn: function() {
        return [_c('ul', {
          staticClass: "absolute z-10 bg-white border border-solid w-56 py-1 px-1 border-gray-200 rounded-lg mt-2 shadow-sm"
        }, [_c('li', {
          staticClass: "px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2",
          on: {
            "click": function($event) {
              return _vm.handleChangeType('All')
            }
          }
        }, [_c('div', {
          staticClass: "flex items-center justify-center rounded-full h-6 w-6 bg-blueGray-700"
        }, [_c('img', {
          staticClass: "w-3 h-3",
          attrs: {
            "src": "/static/roundtable_icons/all_roundtables.svg"
          }
        })]), _vm._v(" "), _c('span', [_vm._v("All Discussions")])]), _vm._v(" "), _c('li', {
          staticClass: "px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2",
          on: {
            "click": function($event) {
              return _vm.handleChangeType('Sequence')
            }
          }
        }, [_c('div', {
          staticClass: "flex items-center justify-center rounded-full pl-0.5 h-6 w-6 bg-purple-light"
        }, [_c('img', {
          staticClass: "w-2.5 h-2.5",
          attrs: {
            "src": "/static/roundtable_icons/sequence_icon.svg"
          }
        })]), _vm._v(" "), _c('span', [_vm._v("Sequences")])]), _vm._v(" "), _c('li', {
          staticClass: "px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2",
          on: {
            "click": function($event) {
              return _vm.handleChangeType('Written')
            }
          }
        }, [_c('div', {
          staticClass: "flex items-center justify-center rounded-full h-6 w-6 bg-blue"
        }, [_c('img', {
          staticClass: "w-3 h-3",
          attrs: {
            "src": "/static/roundtable_icons/written_icon.svg"
          }
        })]), _vm._v(" "), _c('span', [_vm._v("Written RoundTable")])]), _vm._v(" "), _c('li', {
          staticClass: "px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2",
          on: {
            "click": function($event) {
              return _vm.handleChangeType('Verbal')
            }
          }
        }, [_c('div', {
          staticClass: "flex items-center justify-center rounded-full h-6 w-6 bg-green-light"
        }, [_c('img', {
          staticClass: "w-3 h-3",
          attrs: {
            "src": "/static/roundtable_icons/verbal_icon.svg"
          }
        })]), _vm._v(" "), _c('span', [_vm._v("Verbal RoundTable")])])])]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row space-x-2"
  }, [_c('DropdownMenu', {
    scopedSlots: _vm._u([{
      key: "toggle",
      fn: function() {
        return [_c('button', {
          staticClass: "bg-white opacity-90 h-10 w-28 rounded-lg py-2 px-4 flex text-gray-700 items-center justify-between space-x-2"
        }, [(_vm.selected_status === 'All Status') ? _c('span', [_vm._v("All Status")]) : _vm._e(), _vm._v(" "), (_vm.selected_status === 'Active') ? _c('span', {
          staticClass: "w-28"
        }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (_vm.selected_status === 'Closed') ? _c('span', {
          staticClass: "text-red-500"
        }, [_vm._v("Closed")]) : _vm._e(), _vm._v(" "), _c('i', {
          staticClass: "fa-solid text-xs fa-chevron-down text-gray-700"
        })])]
      },
      proxy: true
    }, {
      key: "menu-content",
      fn: function() {
        return [_c('ul', {
          staticClass: "absolute z-10 bg-white border border-solid w-28 border-gray-200 rounded-lg mt-2 py-1 px-1 shadow-sm"
        }, [_c('li', {
          staticClass: "px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2",
          on: {
            "click": function($event) {
              return _vm.handleChangeStatus('All Status')
            }
          }
        }, [_c('span', [_vm._v("All Status")])]), _vm._v(" "), _c('li', {
          staticClass: "px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2",
          on: {
            "click": function($event) {
              return _vm.handleChangeStatus('Active')
            }
          }
        }, [_c('span', [_vm._v("Active")])]), _vm._v(" "), _c('li', {
          staticClass: "px-3 py-2 rounded-md cursor-pointer hover:bg-red-50 flex items-center space-x-2",
          on: {
            "click": function($event) {
              return _vm.handleChangeStatus('Closed')
            }
          }
        }, [_c('span', {
          staticClass: "text-red-500"
        }, [_vm._v("Closed")])])])]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('DropdownMenu', {
    scopedSlots: _vm._u([{
      key: "toggle",
      fn: function() {
        return [_c('button', {
          staticClass: "bg-white opacity-90 h-10 w-32 rounded-lg py-2 px-4 flex text-gray-700 items-center justify-between space-x-2"
        }, [(_vm.selected_order === '') ? _c('span', {
          staticClass: "text-gray-700"
        }, [_vm._v("Order by")]) : _vm._e(), _vm._v(" "), (_vm.selected_order === 'created_at') ? _c('span', {
          staticClass: "text-gray-700"
        }, [_vm._v("Created At")]) : _vm._e(), _vm._v(" "), (_vm.selected_order === 'title') ? _c('span', {
          staticClass: "text-gray-700"
        }, [_vm._v("Title")]) : _vm._e(), _vm._v(" "), _c('i', {
          staticClass: "fa-solid text-xs fa-chevron-down text-gray-700"
        })])]
      },
      proxy: true
    }, {
      key: "menu-content",
      fn: function() {
        return [_c('ul', {
          staticClass: "absolute z-10 bg-white border border-solid w-32 border-gray-200 rounded-lg mt-2 shadow-sm py-1 px-1"
        }, [_c('li', {
          staticClass: "px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2",
          on: {
            "click": function($event) {
              return _vm.handleChangeOrder('created_at')
            }
          }
        }, [_c('span', [_vm._v("Created At")])]), _vm._v(" "), _c('li', {
          staticClass: "px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2",
          on: {
            "click": function($event) {
              return _vm.handleChangeOrder('title')
            }
          }
        }, [_c('span', [_vm._v("Title (A-Z)")])])])]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "flex items-center justify-center rounded-lg bg-white opacity-90 hover:bg-primary-new_light h-10 w-10",
    on: {
      "click": _vm.goToBannerTab
    }
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/edit.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "flex items-center justify-center rounded-lg bg-pinky opacity-90 text-white h-10 px-6",
    on: {
      "click": function($event) {
        return _vm.joinToRT()
      }
    }
  }, [_vm._v("\n            Join RoundTable\n          ")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5"
  }, [_c('div', {
    staticClass: "grid grid-flow-row grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 my-5"
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "h-56",
    on: {
      "click": function($event) {
        return _vm.handleOpenNewRoundTable()
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageOfRoundtables), function(roundtable, index) {
    return _c('RoundTableCard', {
      key: index,
      attrs: {
        "type": roundtable.content_type ? roundtable.content_type : roundtable.type,
        "title": roundtable.title,
        "updated_at": roundtable.updated_at,
        "course_name": _vm.getCourseDetail.title,
        "sequence_roundtables": roundtable.roundtables,
        "course_id": _vm.getCourseDetail.id,
        "id": roundtable.id,
        "roundtable": roundtable,
        "author_id": roundtable.author_id,
        "students_count": roundtable.students_count,
        "is_ended": roundtable.is_ended,
        "end_date": roundtable.end_date,
        "is_sample": roundtable.is_sample,
        "edlink_integrations": roundtable.edlink_integrations,
        "classroom_integration": roundtable.google_classroom_course_work_id,
        "sequence_id": roundtable.sequence_id,
        "submissions_started_written": roundtable.submissions_started,
        "users": roundtable.users_invited
      },
      on: {
        "handleOpenModalSequence": function (value) { return _vm.handleOpenSequence(value); },
        "duplicateRT": function (roundtable) { return _vm.RtToDuplicate(roundtable); },
        "editRT": function (roundtable) { return _vm.RtToEdit(roundtable); },
        "deleteRT": function (roundtable) { return _vm.RtToDelete(roundtable); },
        "showFollowUp": function (roundtable) { return _vm.handleStartFollowUP(roundtable); },
        "close_sequence_card": function (status) { return _vm.handleCloseSequence(status); },
        "handleOpenDraft": function (draft) { return _vm.handleClickDraft(draft); }
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "my-10"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.searched_roudtables,
      "pageSize": 14,
      "labels": _vm.customLabels
    },
    on: {
      "changePage": _vm.onChangeCoursesPage
    }
  })], 1)]), _vm._v(" "), (
    (_vm.searched_roudtables.length === 0 && _vm.searchString !== null) ||
    (_vm.searched_roudtables.length === 0 && _vm.rtStatus !== 'all') ||
    (_vm.searched_roudtables.length === 0 && _vm.rtType !== 'all')
  ) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('button', {
    staticClass: "bg-primary rounded font-medium px-5 py-2 text-xs text-white",
    on: {
      "click": function($event) {
        return _vm.clearAllFilters()
      }
    }
  }, [_vm._v("\n        Clear Filters\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.show_duplicate_modal) ? _c('DuplicateRoundtableModal', {
    attrs: {
      "rt_selected": _vm.rt_selected,
      "is_live_roundtable": _vm.rt_selected.is_active === undefined
    },
    on: {
      "close": function($event) {
        _vm.show_duplicate_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDraftOpen === true) ? _c('Draft', {
    attrs: {
      "id": _vm.selectedDraft.id,
      "type": _vm.selectedDraft.type,
      "isFollowUp": _vm.isToStartFollowUp,
      "gradeLevel": _vm.selectedGradeLevel
    },
    on: {
      "close": function($event) {
        _vm.isDraftOpen = false
      },
      "handleOpenDraft": function (draft) { return _vm.handleClickDraft(draft); }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_edit_rt_modal) ? _c('EditWrittenRoundTable', {
    attrs: {
      "id": _vm.rt_selected
    },
    on: {
      "close": _vm.closeEditRoundtableModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_edit_lrt_modal) ? _c('EditVerbalRoundTable', {
    attrs: {
      "id": _vm.rt_selected
    },
    on: {
      "close": _vm.closeEditRoundtableModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.open_create_roundtable_modal) ? _c('GenerateRoundTable', {
    on: {
      "close": function($event) {
        return _vm.handleCloseNewRoundTableModal()
      },
      "handleStartDraft": function (info) { return _vm.handleOpenDraft(info); }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_sequence_modal_open === true) ? _c('SequenceModal', {
    attrs: {
      "title": _vm.sequence_details.title,
      "course_name": _vm.sequence_details.course_name,
      "course_id": _vm.sequence_details.course_id,
      "created_at": _vm.sequence_details.created_at,
      "sequence_roundtables": _vm.sequence_details.roundtables,
      "author_id": _vm.sequence_details.author_id,
      "users": _vm.sequence_details.users
    },
    on: {
      "close": function($event) {
        _vm.is_sequence_modal_open = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_delete_rt_modal) ? _c('DeleteRoundTable', {
    attrs: {
      "roundtable_id": _vm.rt_selected.id,
      "roundtable_name": _vm.rt_selected.title
    },
    on: {
      "delete_roundtable": function (roundtable_id) { return _vm.deleteRoundtable(roundtable_id); },
      "close": function($event) {
        _vm.show_delete_rt_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "border hover:bg-trueGray-100 border-dashed border-coolGray-300 bg-coolGray-50 rounded-md cursor-pointer h-full flex flex-col items-center my-auto"
  }, [_c('div', {
    staticClass: "center items-center text-center my-auto px-3"
  }, [_c('img', {
    staticClass: "center mb-4",
    attrs: {
      "src": "/static/logos/new_roundtable_icon.svg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "uppercase font-semibold text-xl text-blueGray-700 mt-3"
  }, [_vm._v("\n              New RoundTable\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center mb-3"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info text-lg mb-2"
  }), _vm._v(" "), _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("No RoundTables Found")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0e5380ac!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/roundtablesCourseTable.vue
// module id = 977
// module chunks = 61